import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'spt-update-subscription-success',
  templateUrl: './update-subscription-success.component.html',
  styleUrls: ['./update-subscription-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateSubscriptionSuccessComponent {}
